export default __webpack_public_path__ + "static/media/Driver.dc391bee.svg";